export default function(series){for(var n=series.length,o=new Array(n);--n>=0;)o[n]=n;return o}